<template>
    <Wrapper :showBack="false">
        <template #content>
            <van-loading class="fixed" size="50" />
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Loading } from 'vant';
import Wrapper from './Wrapper.vue';

Vue.use(Loading);

export default {
    name: 'RevokeLoading',
    components: {
        Wrapper,
    },
};
</script>

<style scoped>
.van-loading {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
